<template>
  <div class="form-collapse layer_SaveBz">
    <div class="info">
      <layui-form ref="saveBz" :outside="outside">
        <div v-if="visible" class="layui-form">
          <!-- <pub-collapse
            :title="'节点信息'"
          >
            <template #content> -->
          <!-- <layui-collapse ref="collapse"> -->
          <div class="layui-colla-item">
            <!-- <h2 class="layui-colla-title">节点基本信息</h2> -->
            <div class="layui-colla-content layui-show">
              <div class="bz-item">
                <label class="layui-form-label">{{ formData.title ? formData.title + '-施工要求说明：' : nodeitem.text.value + '-施工要求说明：' }}</label>
                <textarea v-model="formData.bz" class="layui-textarea" />
              </div>
              <div class="bz-item">
                <label class="layui-form-label">参照图例：</label>
                <layui-fileupload v-model="formData.imgId"  targetEl=".layer_SaveBz">
                    <template slot-scope="{ scope }">
                      <button type="button" class="file-upload layui-btn layui-btn-primary" @click="scope.upload()">
                        <i class="layui-icon"></i>上传图片
                      </button>
                    </template>
                </layui-fileupload>
              </div>
              <div class="bz-item">
                <label class="layui-form-label">操作手册：</label>
                <layui-fileupload v-model="formData.fileId"  targetEl=".layer_SaveBz">
                  <template slot-scope="{ scope }">
                    <button type="button" class="file-upload layui-btn layui-btn-primary" @click="scope.upload()">
                      <i class="layui-icon"></i>上传文件
                    </button>
                  </template>
                </layui-fileupload>
              </div>

              <div class="bz-item" v-if="false">
                <label class="layui-form-label">{{ '节点库-备注：' }}</label>
                <textarea v-model="formData.gNode.NODE_REMARKS" :disabled="true" class="layui-textarea" />
                <layui-fileupload v-model="formData.gNode.NODE_FS" targetEl=".layer_SaveBz" />
              </div>
            </div>
          </div>
          <!-- </layui-collapse> -->
          <!-- </template>
          </pub-collapse> -->
        </div>
        <div class="layui-form-btn">
          <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">
            关 闭
          </button>
          <button class="layui-btn" title="保存" @click="handleBtnclick('save')">
            保 存
          </button>
        </div>
      </layui-form>
    </div>
  </div>
</template>

<script>
/** BPM 节点附加信息弹窗 */
export default {
  name: 'Layer_SaveBz',
  props: {
    nodeitem: {
      type: Object,
      default: () => ({})
    },
    visible: { type: Boolean, default: false },
    lf: Object || String,
  },
  data() {
    return {
      outside: undefined,
      /** 底部按钮触发标记 */
      btnEmitFlag: false,
      visCloseFlag: false,
      formData: {
        title: '',
        bz: '',
        imgId:'',
        fileId: '',
        tipShow: false,
        gNode: {
          NODE_REMARKS: '',
          NODE_FS: ''
        }
      }
    }
  },
  watch: {
    visible: {
      handler: function(val) {
        if (val) {
          this.$refs.saveBz.openPopRight(null, 'auto', this.close_callBack, $(this.outside))
        } else {
          // 会触发 close_callBack 回调
          this.$refs.saveBz.close()
        }
      }
    },
    nodeitem: {
      handler: function(val){
        if(val){
          this.recordData(val)
        }
      }
    }
  },
  mounted() {
    this.outside = '.bpm-container'
    this.recordData(this.$props.nodeitem)
  },
  methods: {
    /**
     * 重新赋值
     */
    recordData(data){
        if(JSON.stringify(this.nodeitem) !='{}'){
          const { properties, text } = data;
          if (properties) {
            this.formData = Object.assign({}, this.formData, properties.node, data.gNode)
          }
          if (text && text.value) {
            this.formData.title = text.value;
            this.formData.bz= properties.bz;
            this.formData.imgId = properties.imgId;
            this.formData.fileId = properties.fileId;
            this.formData.tipShow = true
          }
    }
    },
    /**
     * form弹窗关闭的回调
     */
    close_callBack(ev) {
      if (!this.btnEmitFlag) {
        this.btnEmitFlag = true
        this.$emit('cancel', { type: 'close' })
      } else {
        this.btnEmitFlag = false
      }
    },
    /**
     * 保存、关闭
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.btnEmitFlag = 'close'
          this.$emit('cancel', { type: 'cancel' })
          break
        }
        case 'save': {
          this.btnEmitFlag = 'save'
          const { id } = this.$props.nodeitem
          this.$props.lf.setProperties(id, {
            ...this.formData
          });
          this.$emit('save')
          break
        }
        default: {
          break
        }
      }
    }
  }
}
</script>

<style lang="postcss">
.layer_SaveBz {
  & .magnify-modal {
    z-index: 20211021;
  }

  & .layui-layer-wrap {
    height: 100%;
    overflow: auto;
  }

  & .bz-item {
    padding-bottom: 16px;
    width: 100%;

    & .layui-form-label {
      width: auto;
      padding: 9px 0;
      color: #333;
      font-weight: 500;
    }
    & .file-upload {
      height: 32px;
      line-height: 32px;
      background: #fff;
      margin-top: 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/newBpm/saveBz.vue